import React from "react";
import { Link } from "react-router-dom";
type ButtonVariant = "primary" | "secondary" | "inverse";
type ButtonLinkProps = {
  to: string;
  variant?: ButtonVariant;
  className?: string;
  children: React.ReactNode;
  ariaLabel?: string;
};
const base = "group/btn inline-flex min-h-[52px] items-center justify-center gap-2 whitespace-nowrap rounded-full px-7 py-3 text-[16px] font-semibold leading-none transition-[background-color,color,border-color,transform,box-shadow] duration-150 ease-out active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-charcoal focus-visible:ring-offset-2 focus-visible:ring-offset-paper [&>svg]:transition-transform [&>svg]:duration-150 hover:[&>svg]:translate-x-0.5";
const variants: Record<ButtonVariant, string> = {
  primary: "bg-ocean text-charcoal shadow-[0_6px_18px_-8px_rgba(41,171,226,0.9)] hover:bg-ocean-light hover:shadow-[0_10px_24px_-10px_rgba(41,171,226,1)]",
  secondary: "border-[1.5px] border-charcoal text-charcoal hover:bg-charcoal hover:text-paper",
  inverse: "border-[1.5px] border-paper/70 text-paper hover:bg-paper hover:text-charcoal focus-visible:ring-paper focus-visible:ring-offset-charcoal"
};
export function buttonClass(variant: ButtonVariant = "primary", className = ""): string {
  return `${base} ${variants[variant]} ${className}`.trim();
}
export function ButtonLink({
  to,
  variant = "primary",
  className = "",
  children,
  ariaLabel
}: ButtonLinkProps) {
  return <Link to={to} className={buttonClass(variant, className)} aria-label={ariaLabel} data-id="element-433" data-mp="1gv6fi4bkw8mo">
      {children}
    </Link>;
}